<template>
    <b-container>
        <h2 v-if="error">No existen usuarios inactivos</h2>
        <List v-else :items="users" :fields="fields"/>
    </b-container>
</template>

<script>
    import List from '@/components/admin/InactiveList'
    import {mapActions,mapState} from 'vuex'
    export default {
        components:{
            List
        },    
        data:function () {
            return{
                fields:['username','email','name','telefono','Acciones']
            }            
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('admin',['users','error'])
        },
        methods:{
            ...mapActions({
                _fetchUsers: 'admin/fetchInactiveUsers'   
            }),
            init(){
                this._fetchUsers()
            }
        }    
    }
</script>

<style lang="scss" scoped>

</style>